import { Container, InputAdornment, TextField } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import { useTranslation } from "react-i18next";

const SearchBar = (props) => {
    const { t } = useTranslation("translation");

    return (
        <Container>
            <TextField
                id="search_bar"
                className="text"
                value={props.value}
                onInput={(e) => {
                    props.onChange(e.target.value);
                }}
                onKeyPress={(event) => {
                    if (event.key === "Enter") {
                        props.onRequestSearch(props.value);
                        event.preventDefault();
                    }
                }}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <IconButton id="search_bar_Search" onClick={() => props.onRequestSearch(props.value)}>
                                <SearchRoundedIcon />
                            </IconButton>
                        </InputAdornment>
                    ),
                    endAdornment: (
                        <InputAdornment position="end">
                            {props.value.length > 0 ? (
                                <IconButton
                                    id="search_bar_Clear"
                                    onClick={() => {
                                        props.onChange("");
                                        props.onRequestSearch("");
                                    }}
                                >
                                    <ClearRoundedIcon />
                                </IconButton>
                            ) : null}
                        </InputAdornment>
                    ),
                }}
                variant={props.variant ?? "outlined"}
                placeholder={t("Search")}
                size={props.size ?? "small"}
                sx={props.style ?? { width: "100%" }}
                helperText={props.helperText ? t("SearchPlannedMaintenance") : null}
            />
        </Container>
    );
};

export default SearchBar;
